module.exports = __webpack_public_path__ + "img/Handrolstoel.62eefe95.svg";